/**
 * API functions for system mode (test mode / JobLogic).
 */

import api from './client';

/**
 * Get current system mode status.
 */
export async function getSystemMode() {
  const res = await api.get('/system/system-mode/');
  return res.data.data;
}

/**
 * Toggle test mode.
 * @param {string} action - 'enable', 'disable', or 'toggle'
 */
export async function setSystemMode(action) {
  const res = await api.post('/system/system-mode/', { action });
  return res.data.data;
}

/**
 * Reset test database to clean state.
 * Requires confirmation flag.
 */
export async function resetTestDatabase() {
  const res = await api.post('/system/system-mode/reset-test-db/', { confirm: true });
  return res.data.data;
}
